import './TextPanel.scss';

export { default as TextPanel } from './TextPanel';
export { default as textPanelSchema } from './textPanelSchema';
